import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

tippy('[data-tippy-content]');